export const isAddressCellEditable = ({ field, row }) => {
  if (field === 'adressType' && !row?.isNew) return false;

  return true;
};

export const getAddressTableEditableFields = (apiRef, rowId) => {
  const allCols = apiRef.current.getVisibleColumns?.() ?? [];
  const row = apiRef.current.getRow?.(rowId);

  const editableFields = allCols
    .filter((c) => c.type !== 'actions' && c.editable)
    .filter((c) => {
      return isAddressCellEditable({ field: c.field, row });
    })
    .map((c) => c.field);

  return editableFields;
};

export const getTableEditableFields = (apiRef) => {
  const allCols = apiRef.current.getVisibleColumns?.() ?? [];

  const editableFields = allCols.filter((c) => c.type !== 'actions' && c.editable).map((c) => c.field);

  return editableFields;
};
